<template>
  <div :class="{
      'invisible': total <= 0
    }" class="transition-alpha">
    <div class="flex justify-between font-light text-14 text-black-80">
      <div>{{ total }} Question<span v-if="total > 1">s</span></div>
      <div class="text-right">{{ count }}/{{ total }}</div>
    </div>
    <div class="w-full h-2 overflow-hidden rounded-lg bg-lightgrey-d">
      <div
        :style="{
            transform: `scaleX(${count/total})`,
          }"
        class="w-full h-full ml-0 mr-auto bg-theme-highlight scalex-0"
      ></div>
    </div>
  </div>
</template>

<script>
import { get } from "@/vue/store/_ajax"
export default {
  props: ['slug'],
  data() {
    return {
      questions: []
    }
  },
  computed: {
    count() {
      let count = 0
      if ( !this.questions ) return count

      if (this.questions.length) {
        this.questions.forEach(({ answers }) => {
          if (answers.hasAnswered) {
            count += 1
          }
        })
      }

      return count
    },
    total() {
      return this.questions ? this.questions.length : 0
    }
  },
  mounted() {
    this.getPoll()
  },
  methods: {
    async getPoll() {
      const { data: response } = await get('polls/get-poll', { slug: this.slug })
      if (response.success) {
        const { data } = response
        if (data) {
          const { questions } = data
          if ( questions && questions.length ) {
            this.questions = questions
          }
        }
      }
    }
  }


}
</script>

<style scoped>
.scalex-0 {
  transform: scaleX(0);
  transition: transform 0.3s ease;
  transform-origin: left;
}
</style>
